<template>
  <div class="tabs-body">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'GuluTabsBody',
  }
</script>
<style>
</style>